var _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _path6, _circle, _path7, _path8, _path9, _path10, _path11, _path12, _rect2, _polygon3, _polygon4, _polygon5, _path13, _path14, _path15, _ellipse5, _path16, _path17, _path18, _path19, _path20, _path21, _ellipse6, _rect3, _ellipse7, _ellipse8, _rect4, _ellipse9, _ellipse10, _rect5, _ellipse11, _ellipse12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 882.65452,
    height: 624.26423,
    viewBox: "0 0 882.65452 624.26423",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 650.91616,
    y: 401.0839,
    width: 7.81019,
    height: 67.36288,
    transform: "translate(-224.35236 611.04752) rotate(-57.13996)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 683.11368,
    cy: 453.04054,
    rx: 23.43057,
    ry: 5.85766,
    transform: "matrix(0.54259, -0.84, 0.84, 0.54259, -226.76223, 643.1724)",
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 626.5289,
    cy: 416.49016,
    rx: 23.43057,
    ry: 5.85766,
    transform: "translate(-221.94248 578.92272) rotate(-57.13996)",
    fill: "#2f2e41"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 657.20584,
    cy: 607.06899,
    rx: 225.44868,
    ry: 17.19524,
    fill: "#e6e6e6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.44868,
    cy: 524.6538,
    rx: 225.44868,
    ry: 17.19524,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1001.3292,662.48459a294.26751,294.26751,0,0,1-13.746,81.3449c-.19151.61112-.39221,1.21311-.59286,1.82428h-51.299c.05473-.54732.10951-1.15844.16423-1.82428,3.42054-39.32253,23.14106-278.65052-.43786-319.57842C937.4792,427.57128,1005.30613,537.53922,1001.3292,662.48459Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M997.48,743.82949c-.42873.61112-.87567,1.22224-1.33174,1.82428H957.66493c.29189-.51993.62938-1.131,1.02159-1.82428,6.35767-11.47478,25.17512-45.78046,42.64268-81.3449,18.77192-38.21881,35.99318-77.88789,34.54285-92.245C1036.319,573.47767,1049.30789,672.18975,997.48,743.82949Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M637.84005,703.4384a149.36551,149.36551,0,0,0,6.97725,41.28939c.09721.3102.19908.61576.30093.926h26.03855c-.02778-.27781-.05559-.588-.08337-.926-1.73621-19.95949-11.746-141.43862.22226-162.213C670.24931,584.2001,635.82142,640.0181,637.84005,703.4384Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M639.79385,744.72779c.21762.3102.44448.62039.676.926h19.53352c-.14816-.26391-.31947-.5741-.51855-.926-3.227-5.82441-12.77849-23.23743-21.64475-41.28939-9.52833-19.39926-18.26957-39.53467-17.53341-46.82211C620.07978,658.25989,613.48682,708.36459,639.79385,744.72779Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M671.07385,399.80734s-43.50121,42.63117-25.23072,47.85131,39.15108-39.15107,39.15108-39.15107Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#a0616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "555.902 405.493 550.682 429.854 589.833 431.594 583.743 405.493 555.902 405.493",
    fill: "#a0616a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "679.446 556.007 674.226 580.368 713.377 582.108 707.286 556.007 679.446 556.007",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M769.38653,380.66681l3.48011,13.92038s-96.57264-19.14055-91.3525,29.5808,27.84077,95.70265,27.84077,95.70265-1.74,15.66045,1.74,18.27049,0,11.31031,0,11.31031,32.1909,4.35013,33.06092-3.48006a54.56676,54.56676,0,0,0-.87-15.66044s1.74,0,0-8.70024-8.76889-78.86547-13.989-88.43575c0,0,46.17994,35.36427,70.54059,31.01411,0,0-3.48011,34.801,10.44029,80.91225S824.198,596.43272,824.198,596.43272s16.53046,87.87243,12.18033,98.31272l-.87,4.35013H867.6992s-2.61005-46.11125,0-52.20142,2.6101-58.29158-12.18032-84.39231c-10.47395-18.48353-8.52313-72.07681-2.79394-93.26023,4.81124-17.78918,6.02623-31.48065,3.20593-49.69185-3.016-19.47493-12.02222-29.65481-23.03257-38.88295Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 636.37954,
    cy: 80.53943,
    r: 31.32088,
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M786.78705,240.59292s9.57028,27.84078,8.70026,33.06091,27.84077-10.44029,27.84077-10.44029-11.31031-27.84078-7.8302-35.671Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M821.588,253.64329l-30.45081,12.18034,1.74,10.44029s-2.61005,3.4801-1.74,5.22015-11.31031,8.70023-9.57028,11.31031-10.44029,13.05035-9.57028,15.66044-27.84076,18.27051-12.18032,48.72135c0,0,8.1195,10.55533,7.10209,23.03778q-.05356.658-.14186,1.32288c-1.74,13.05036,66.12182-1.74,66.12182-1.74V365.00637s6.09017-2.61008,5.22015-13.92039-6.09016-6.09016,0-12.18032,6.09016-5.22015,5.22015-10.4403c-.34742-2.08456-.41738-9.57987-.37609-17.83215a79.1676,79.1676,0,0,0-16.15437-48.28961h0Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#f9a826"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M805.05754,276.26392,748.506,335.42554,665.8537,400.67736l18.27049,14.7904L836.37842,313.67494S849.42876,257.99341,805.05754,276.26392Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#f9a826"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M717.18511,556.41167s-6.09017-10.44029-10.4403-6.96018L676.294,573.81215s-53.94151,15.66044-1.74,27.84076c0,0,28.71079,4.35013,34.801,0s15.66044-3.48011,18.27049-1.74,35.671-.87,35.671-7.8302-18.23414-37.37944-18.23414-37.37944S734.58558,566.85192,717.18511,556.41167Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M840.7285,706.92582s-6.09016-10.4403-10.44029-6.96018l-30.45082,24.36065s-53.9415,15.66044-1.74,27.84077c0,0,28.71078,4.35013,34.80094,0s15.66045-3.48012,18.27049-1.74,35.671-.87,35.671-7.8302-18.2341-37.37944-18.2341-37.37944S858.129,717.36611,840.7285,706.92582Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M757.51669,205.986s5.29577-46.552,50.58886-33.33436c0,0,32.04224-6.51744,43.3595,33.50169l11.487,41.95714-5.25811-2.73243-2.32417,5.34954-8.39144,2.29741-3.746-7.0928-1.5786,8.731-57.95072,11.71641s19.59887-22.39274,19.45984-55.189l-5.77258,6.33962Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 215.17496,
    y: 30.26495,
    width: 72.44679,
    height: 90.34275,
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "155.351 451.681 145.472 488.038 161.938 500.157 166.328 496.852 174.012 459.393 155.351 451.681",
    fill: "#ffb8b8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "279.389 448.376 276.096 492.445 296.952 492.445 296.952 451.681 279.389 448.376",
    fill: "#ffb8b8"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.528 169.635 213.528 196.077 254.143 202.687 289.268 188.365 282.682 171.838 213.528 169.635",
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M405.13155,329.53788l-35.1257-6.61045-8.78141,71.61315-21.95359,89.241s-32.93037,76.02012-28.53962,93.648l2.19538,5.50872-2.19538,9.91569,21.95358,8.81391,8.78142-14.32259s6.58608,9.91568,17.56287-11.01742,57.07929-150.93857,57.07929-150.93857l7.68375,22.03481a45.56894,45.56894,0,0,0-1.09766,20.93307c2.19537,11.01739,4.3907,45.17135,4.3907,45.17135s-12.07445,59.494,4.39071,63.901l3.293,13.22091,23.05125,2.2035,4.39071-13.22091s21.95358-7.71218,16.46516-46.2731S470.9923,368.0988,470.9923,368.0988l-21.62485-53.51628Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M310.73119,623.7027s-5.48842-4.407-7.68375-3.30523-25.24663,30.84874-25.24663,30.84874-24.149,18.72959-6.58608,20.9331,65.86075-22.03483,65.86075-27.54351S326.927,625.33066,326.927,625.33066,319.5126,631.41493,310.73119,623.7027Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M432.57356,620.39747s19.7582-1.23188,23.05124,2.1384,2.19538,19.89643,2.19538,19.89643,2.19538,29.747-15.3675,29.747S429.28051,652.348,429.28051,652.348Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#2f2e41"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.14256,
    cy: 45.13845,
    rx: 27.44196,
    ry: 27.54352,
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M394.70362,200.08332s15.3675,18.7296-15.3675,33.05223,21.95358,73.81664,21.95358,73.81664,61.47-23.13655,55.98162-68.30795c0,0-37.32108-6.61044-28.53962-37.45919Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#ffb8b8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M378.23845,232.03381s-25.24662-3.30522-26.34429,17.62786,0,71.61314,0,71.61314-10.97679,44.06965-5.48837,82.63057c0,0-6.58608,45.17138,10.97679,42.9679s4.39071-46.27313,4.39071-46.27313L369.457,328.987l-3.293-52.88355L380.43379,244.153Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M450.89756,236.9011s23.93664-.46034,25.03431,17.16752-7.68375,71.61317-7.68375,71.61317L455.076,332.29225l-12.07446-37.4592Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#ffb8b8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M457.82018,327.33438l-2.19538,5.50871,6.58609,16.52612s-26.34429,20.93307-24.149,25.34,14.26978-5.50871,14.26978-5.50871l17.56288,8.81394s14.26979-15.42437,7.68375-29.747a166.5604,166.5604,0,0,1-9.13-23.835S458.9178,324.02918,457.82018,327.33438Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#ffb8b8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M373.29889,228.17772l-3.293,36.35744s-15.3675,15.42437,2.19538,36.35744l-2.19538,16.52612s40.61412-2.20348,48.29787,0,31.41348-1.77407,31.41348-1.77407l.41918-12.54857s10.9768-15.42437,7.68375-38.56093,0-30.84875,0-30.84875l-7.68375-1.10174s-4.93956,33.6031-38.9676,36.90832c0,0-42.26064,3.85609-30.18619-41.31529Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M415.55954,138.38582S387.01992,136.61,380.43383,154.423s-18.11168,27.16469-18.11168,27.16469-18.15567,12.667-9.07784,35.27949c0,0-28.24324,19.04992-9.5827,35.97219,0,0-1.09767,16.92227,9.87912,28.50067,0,0,8.78142,4.45324,5.48842,7.12516s21.95358.89066,19.75821-23.1568,12.62331-40.98675,12.62331-40.98675-14.26979-31.1784-7.68375-41.86616c3.9987-6.489,5.71592-11.328,9.03539-14.12859a41.71376,41.71376,0,0,0,5.12434-5.01953A11.79833,11.79833,0,0,1,410.62,159.3215c9.87913,2.67194,12.07446,10.68774,12.07446,10.68774s7.13489,19.14889,19.20939,28.05536-9.33027,24.49276-9.33027,24.49276,3.72063,18.35058,13.38594,29.21482-2.78542,20.33429-3.50681,21.552c-1.64652,2.77925-8.222,20.32937,18.94024,20.40712,0,0,6.30634-13.282,15.0878-21.29775s2.19538-31.17262,2.19538-31.17262,13.17216-8.01581-1.09767-27.61c0,0,4.39071-17.81293-7.68375-29.39132C469.89464,184.25959,452.88062,132.15131,415.55954,138.38582Z",
    transform: "translate(-158.67274 -137.86789)",
    fill: "#2f2e41"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.50528,
    cy: 44.58757,
    rx: 2.74419,
    ry: 4.40697,
    fill: "#ffb8b8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.07049,
    y: 499.03518,
    width: 67.36288,
    height: 7.81019,
    fill: "#2f2e41"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.43345,
    cy: 502.94027,
    rx: 5.85766,
    ry: 23.43057,
    fill: "#2f2e41"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.07049,
    cy: 502.94027,
    rx: 5.85766,
    ry: 23.43057,
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.07949,
    y: 499.03518,
    width: 67.36288,
    height: 7.81019,
    fill: "#2f2e41"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.44244,
    cy: 502.94027,
    rx: 5.85766,
    ry: 23.43057,
    fill: "#2f2e41"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.07949,
    cy: 502.94027,
    rx: 5.85766,
    ry: 23.43057,
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 776.41768,
    y: 577.76013,
    width: 67.36288,
    height: 7.81019,
    fill: "#2f2e41"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 843.78063,
    cy: 581.66522,
    rx: 5.85766,
    ry: 23.43057,
    fill: "#2f2e41"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 776.41768,
    cy: 581.66522,
    rx: 5.85766,
    ry: 23.43057,
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndraw);
export default __webpack_public_path__ + "static/media/undraw.a19a6b5a9f25a0f05c7d82bb7651d4a9.svg";
export { ForwardRef as ReactComponent };